"use client"
import { useUpdate } from '@/core/hooks/use-update.hook';
import AuthRepo from '@/core/repos/auth.repo';
import ConfigRepo from '@/core/repos/config.repo';
import container from '@/lib/di/container';
import { BellFilled, DownOutlined, MenuFoldOutlined, MenuUnfoldOutlined, MessageFilled, PhoneFilled, UserOutlined } from '@ant-design/icons'
import { bind } from '@react-rxjs/core';
import { Badge, Button, Dropdown, List, MenuProps, Popover } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { ChangeMyPasswordModal } from '../modals/ChangeMyPasswordModal';
import { GlobalUtils } from '../../utils/global.utils';
import { PERMISSIONS } from '@/core/enums/permissions.enum';
import CompanyBrand from '@/app/components/CompanyBrand';
import { factoryRuntimeSettings, useFactoryRuntimeSettings } from '@/core/stores/factory-runtime-settings.store';

const authRepo = container.get(AuthRepo);
const configRepo = container.get(ConfigRepo);

interface HeaderProps{
    onCollapsed: () => void,
    collapsed: boolean
}

interface NotificationModel {
    title: string,
    description: string
}
const NotificationButton = () => {
    const [notifications, setNotifications] = useState<NotificationModel[]>([]);
  
    const content = (
      <List
        dataSource={notifications}
        renderItem={item => (
          <List.Item>
            <List.Item.Meta
              title={item.title}
              description={item.description}
            />
          </List.Item>
        )}
      />
    );
  
    return (
      <div className='mr-2'>
        <Popover
          content={content}
          title="Thông báo"
          trigger="click"
        >
          <Badge count={notifications.length} offset={[-6, 0]}>
            <BellFilled className='text-2xl mx-2 cursor-pointer' style={{color: 'var(--primary-color)'}}/>
          </Badge>
        </Popover>
      </div>
    );
  };

const Header: React.FC<HeaderProps>  = ({onCollapsed, collapsed}) => {
    const detailState = authRepo.useDetails();
    useFactoryRuntimeSettings();
    const factoryName = factoryRuntimeSettings.string("factoryName", process.env.REACT_APP_COMPANY_FACTORY);
    const companyName = factoryRuntimeSettings.string("companyName", process.env.REACT_APP_COMPANY_NAME);
    const claims = authRepo.useClaims();
    const buildStyles = configRepo.useBuildStyles();
    const navigate = useNavigate();
    const [isChangePasswordModal, setChangePasswordModal] = useState(false);
    const canChangePassword = GlobalUtils.checkPerm(claims, PERMISSIONS.ACCOUNT_CHANGEPASSWORD.key);
    //componentDidMount equivalent, run exclusively on client-side

    const dropdownMenu: MenuProps['items'] = [
        ...(canChangePassword ? [{
            key: '2',
            label: (<a>Đổi mật khẩu</a>),
            onClick: changePassword
        }] : []),
        {
            key: '1',
            label: (<a>Đăng xuất</a>),
            onClick: logout
        }
    ]

    function logout() {
        authRepo.logout();
    }

    function changePassword() {
      setChangePasswordModal(true);
    }

    return (<section className='w-full h-[70px] bg-white text-primary border-b border-gray-300 select-none'>
        <div className='w-full h-full py-4 pl-4 pr-8 flex flex-row items-center justify-between'>
            <div className='flex flex-row items-center justify-between w-[300px]'>
                <Button type="text" onClick={onCollapsed}>
                    {collapsed
                        ?<MenuUnfoldOutlined className='text-xl' style={{color: "var(--primary-color)"}}/>
                        :<MenuFoldOutlined className='text-xl' style={{color: "var(--primary-color)"}}/>}
                </Button>
                <a href="/">
                    <CompanyBrand variant="header" logoStyle={buildStyles.get('headerLogo')} />
                </a>
            </div>
            <div className='hidden xl:block flex-1 px-5 truncate text-sm' title={[companyName, factoryName].filter(Boolean).join(' — ')}>{factoryName || companyName}</div>
            <div className='flex flex-row items-center'>
                <NotificationButton />
                <a href="https://zalo.me/0981325335" target="_blank" rel="noreferrer"><Button className='ml-2 mr-4' type="primary" icon={<PhoneFilled/>} style={{
                    background: 'var(--primary-color)',
                    padding: "14px 20px 14px 20px",
                    fontSize: 16
                }}>Hỗ trợ</Button></a>
                <div className='flex flex-row mx-2 border-l h-[60px] items-center pl-6 border-gray-200'>
                    <div className='flex items-center justify-center aspect-square w-[44px] h-[44px] text-gray-600 bg-gray-200 rounded'>
                        <UserOutlined className="text-xl" />
                    </div>
                    <Dropdown menu={{items: dropdownMenu }} placement="bottomRight" trigger={["click"]}>
                        <div className='flex flex-col items-start justify-between text-[15px] leading-0 ml-4 cursor-pointer'>
                            <div className="flex flex-row w-full justify-between">
                                <p>Xin chào</p>
                                <DownOutlined style={{fontSize: 10}}/>
                            </div>
                            <p className='font-bold'>{detailState?.fullName}</p>
                        </div>
                    </Dropdown>
                </div>
            </div>
        </div>
        {isChangePasswordModal&&<ChangeMyPasswordModal isModalOpen={isChangePasswordModal} setIsModalOpen={setChangePasswordModal} />}
    </section>)
}

export default Header;
